import script from "./Delegates.vue?vue&type=script&setup=true&lang=js"
export * from "./Delegates.vue?vue&type=script&setup=true&lang=js"

import "./Delegates.vue?vue&type=style&index=0&id=6ca4fc11&scoped=true&lang=css"

import exportComponent from "/home/jon/Work/ldpos-wallet/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6ca4fc11"]])

export default __exports__